export class UserInfo {
  constructor (name = '', email = '', best_score = 0) {
    this.name = name
    this.email = email
    this.best_score = best_score
  }
}

export class ClubInfo {
  constructor (key = null, name = null, shortName = null) {
    this.key = key
    this.name = name
    this.short_name = shortName
  }
}

export class MedalInfo {
  constructor (name = null, address = null, postNumber = null) {
    this.name = name
    this.address = address
    this.post_number = postNumber
  }
}

export var answerSheet = {
  'level1': ['correct', 'wrong', 'correct'],
  'level2': ['correct', null, null]
}

export var primeGreetings = {
  '0': {
    'failure': 'Rangt svar í fyrstu spurningu. Byrjaðu aftur.'
  },
  '1': {
    'failure': 'Þú þarft að svara 10 spurningum rétt í röð til að verða Regluvörður.'
  },
  '2': {
    'failure': 'Þú þarft að svara 10 spurningum rétt í röð til að verða Regluvörður.'
  },
  '3': {
    'failure': 'Þú þarft að svara 10 spurningum rétt í röð til að verða Regluvörður og eiga meiri möguleika á að vinna glæsilega golfferð fyrir tvo.'
  },
  '4': {
    'failure': 'Þú þarft að svara 10 spurningum rétt í röð til að verða Regluvörður og eiga meiri möguleika á að vinna glæsilega golfferð fyrir tvo.'
  },
  '5': {
    'failure': 'Þú þarft að svara 10 spurningum rétt í röð til að verða Regluvörður og eiga meiri möguleika á að vinna glæsilega golfferð fyrir tvo.'
  },
  '6': {
    'failure': 'Þú þarft að svara 10 spurningum rétt í röð til að verða Regluvörður og eiga meiri möguleika á að vinna glæsilega golfferð fyrir tvo.'
  },
  '7': {
    'failure': 'Þú þarft að svara 10 spurningum rétt í röð til að verða Regluvörður og tífalda vinningsmöguleika þína.'
  },
  '8': {
    'success': 'Nú þarftu að vanda þig. Eitt rétt svar í viðbót og þú ert orðin Regluvörður.',
    'failure': 'Þú þarft að svara 10 spurningum rétt í röð til að verða Regluvörður og eiga meiri möguleika á að vinna glæsilega golfferð fyrir tvo.'
  },
  '9': {
    'failure': 'Feilhögg í síðustu spurningu. Byrjaðu upp á nýtt.'
  }
}

export class GreetingInfo {
  constructor (title = null, text = null, greet_text = null, result = null, imageUrl = null, call_to_text = null, call_to_text_two = null, page_slug = null) {
    this.title = title
    this.text = text
    this.result = result
    this.image_url = imageUrl
    this.greet_text = greet_text
    this.call_to_text = call_to_text
    this.call_to_text_two = call_to_text_two
    this.page_slug = page_slug
  }
}

export class AnswerInfo {
  constructor (questionKey = null, answer = null) {
    this.question_key = questionKey
    this.answer = answer
  }
}

export class LevelInfo {
  constructor (key = null, name = null, level = 0, minValidAnswers = 0, pointsPerAnswer = 0, quesPerLevel = 0, answerSheet = { 'answers': [], 'user_level': null, 'questions': [] }, correctAnswers = 0, wrongAnswers = 0, levelCompleted = null, secondsPerQuestion = 0) {
    this.key = key
    this.name = name
    this.level = level
    this.minimum_valid_answers = minValidAnswers
    this.points_per_answer = pointsPerAnswer
    this.questions_per_level = quesPerLevel
    this.correctAnswers = correctAnswers
    this.wrongAnswers = wrongAnswers
    this.answerSheet = answerSheet
    this.level_completed = levelCompleted
    this.seconds_per_question = secondsPerQuestion
  }
}

export var IcelandicPinCodes = [101, 102, 103, 104, 105, 107, 108, 109, 110, 111, 112, 113, 116, 150, 155, 170, 190, 200, 201, 202, 203, 210, 220, 221, 225, 230, 233, 235, 240, 245, 250, 260, 270, 271, 276, 300, 301, 310, 311, 320, 340, 345, 350, 355, 356, 360, 370, 371, 380, 400, 401, 410, 415, 420, 425, 430, 450, 451, 460, 465, 470, 471, 500, 510, 512, 520, 524, 530, 531, 540, 541, 545, 550, 551, 560, 565, 566, 570, 580, 600, 601, 603, 610, 611, 620, 621, 625, 630, 640, 641, 645, 650, 660, 670, 671, 675, 680, 681, 685, 690, 700, 701, 710, 715, 720, 730, 735, 740, 750, 755, 760, 765, 780, 781, 785, 800, 801, 810, 815, 816, 820, 825, 840, 845, 850, 851, 860, 861, 870, 871, 880, 900]

export class ProtectionForm {
  constructor (name = null, email = null, mobile = null) {
    this.name = name
    this.email = email
    this.mobile = mobile
    this.is_applied = true
    this.user_email = null
  }
}
